module.exports = __webpack_public_path__ + "assets/img/homepage.2aae07b8.png";